module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER ONE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HLOE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("URNER STARED DOWN")])]), _vm._v(" into the black, roiling water, squinting her eyes against the cool spray. The wind ate into her skin. When the boat dipped into a trough, the water rose up, reaching for her, trying to pull her under. She drew her head back as if she could avoid the swipe of the watery paw. Before she could recover from the fear of that close call, the boat tipped up, climbing toward the crest of another wave. The storm had come out of nowhere. She suspected they were in big trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A slender hand settled on her shoulder, offering faint comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I think we might die out here,” Chloe murmured.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hand smacked her arm. Hard. “Oh, for God’s sake, Chloe. It’s a frickin’ ferryboat. Get over yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe tossed a glare at her best friend, Jenn. “We’re in the middle of the ocean. In a storm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“First of all, we’re barely out of the bay. Second, "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("there’s a nine-year-old kid a few feet away who’s having the time of his life.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boat rose on another storm-tossed wave, and Chloe’s stomach dropped. When the boy hooted with excitement, she glared in his direction. “Idiot,” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn smacked her again. “If a reporter heard you say that, you’d be screwed.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They can’t find me on a boat. Isn’t that the reason we’re sailing straight into the perfect storm?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Be nice or I’ll call and alert them to your whereabouts.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe shrugged and pushed a strand of wet brown hair out of her eyes. “I’ll be tipped off when you put on makeup and turn on the cleavage show.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A smile pulled up the corners of her friend’s mouth. “I did look pretty hot last Saturday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe smiled back. “You did. Especially when you put your hand in front of the camera and yelled, ‘She is not an animal!’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, God,” Jenn groaned, using that very same hand to cover her eyes. “I still can’t believe that. It was so chaotic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The good news is that a nineteenth-century London freak show called to offer me a stall. I get to keep half the coins the public pelts at me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Jenn shook her head, the hood of her windbreaker ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("slipping back to expose her gorgeous blond hair. “You’ll never get tired of that joke, will you?”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Never.” As Chloe’s laughter faded, she glanced over her shoulder, as if she could still see the Virginia coastline behind her. “Do you think they followed us?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The photographers?” Jenn’s eyes clouded with worry, but Chloe was already feeling silly. No speeding car had followed them from Richmond. No black van had screeched up to the ferry landing to disgorge a pack of paparazzi. Chloe might feel infamous and trapped by the notoriety thrust upon her by her ex-fiancé, but she wasn’t hunted day and night. Not quite.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No one saw us leave, Chloe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know, I know. Sorry, it’s just—” The ferry swayed forward and a loud thump vibrated up through her knees. “Oh, God!” she cried out, grabbing for the railing. “This is it. We’re going down.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mouth flat with obvious disgust, Jenn shook her head. “We’re at the dock, you coward.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you kidding me?” Chloe looked around, eyes widening at the dark shadow of the dock looming out of the mist. “We made it? Oh, my God, we actually made it!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You won’t have to fight that kid for a seat on the lifeboat, so I’m pretty relieved, too.”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I totally could’ve taken him,” Chloe murmured under her breath as she followed Jenn to the walkway. Jenn must’ve heard her, because she twisted around to give Chloe a narrow look.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Chloe had been a nice, happy person just a month before. The kind of girl who’d never joke about fighting a kid for a seat on a lifeboat. Hopefully, somewhere deep inside, she was still nice, but she’d taken so many brutal blows in the past few weeks that she couldn’t feel anything but the dull pain of layered bruises.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But not right now. Not this week. Jenn had arranged this trip to get Chloe away from the insanity created by her broken engagement. They’d managed to ditch the paparazzi back on the mainland, and there was no roaring speedboat looming out of the mist to catch them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn had assured her that the tiny resort on White Rock Island didn’t have any TVs, and the whole island was limited to fuzzy reception on old-fashioned antennas. This might be the one place where Chloe wouldn’t be recognized.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("The deckhands lowered the walkway to the narrow wooden dock. Drawing a deep breath, Chloe watched a spot of sunlight on the dock expand into a wide patch. When she glanced up toward the heavy gray clouds, the sun burst through like an omen of good days ahead. Her luck was changing. She was ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("sure of it. Even the wind shifted toward the east, warming away the chill she’d caught earlier.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Come on,” Jenn called out, waving toward the short line of people filing onto the dock. At the end of May, the weather wasn’t consistent enough to draw people to the little island. Today, for example, had brought forth a wicked thunderstorm, but now the clouds were shrinking and breaking up, and summer temperatures returned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Chloe set her foot on the dock, which rocked only a little less than the boat, she drew in a deep breath of relief.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn slipped her arm through Chloe’s. “Are you ready to relax?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The resort will pick up our bags. Let’s grab some groceries and head over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sand crunched beneath their feet as they walked toward the buildings gathered around the tiny harbor. The resort was less than half a mile away, according to Jenn, and they could walk or ride bikes while they were here, which meant they’d have to be choosy about their groceries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You brought the margarita mix?” Chloe asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jenn patted her gigantic purse, and a quiet clunk echoed from its depths. “Safe and sound.”")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So we should be good with Lean Cuisines and doughnuts?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t see why not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In the end they added a few more essentials to the list: chips and guac, Diet Coke, marshmallows, and some grapes to counter nutritional guilt. Half an hour later, they were on the porch of their seaside cabin, legs propped on the porch railing and iced margaritas in their plastic cups.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is going to be a great week,” Jenn said brightly. Chloe wasn’t so sure, but the longer she sat there, the more likely that seemed. The Richmond courthouse and Chloe’s ex-fiancé were a whole world away. Maybe two. And Jenn had been right: their little two-bedroom cottage had a kitchen and a bathroom and a porch facing the waves, but one thing it didn’t have was a television.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Better yet, her cell phone showed only one flickering bar, so even if a reporter did manage to get through, Chloe wouldn’t be able to hear him over the constant crash of the waves. She was off the grid, and the idea melted her into the ancient gray wood of her deck chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miracle of miracles, she was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("relaxed.")]), _vm._v(" More herself. But it didn’t feel like she was becoming herself again, exactly. She was reverting to something more primitive. A feral cat sunning itself on the sand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Her muscles gave up their tight hold on her bones. ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Her joints loosened. Chloe slipped her sunglasses on and gave her body and soul up to the beach.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AX")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ULLIVAN GRIPPED")]), _vm._v(" the boat’s railing in numb hands and told himself that everything was okay. His brother was at the helm of his new boat—he’d turned out to be a quick learner—and the storm was subsiding. Max didn’t need to rush over and take control. Elliott was fine. Still, he stared daggers into Elliott’s back, willing him to turn around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Finally, he did. “You want to bring it in?” Elliott called over the wind, tilting his head toward the wheel. “I’m not sure I’m skilled enough for this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max sucked air into his starving lungs and released his death grip on the railing. He hated being on the water. More than that, he hated being on the water during a high wind with a man who didn’t know the first thing about boating. But that was the point. Max couldn’t have let his brother learn the ropes by himself on the open sea. People died like that. So Max just offered his trademark grin and sauntered toward the captain’s chair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure,” he said. “I’ll take her in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Her,” Elliott repeated. “Right. Sea lingo.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elliott had bought the boat to try to prove to himself that he wasn’t a workaholic, but now he looked troubled by the idea of learning how to have fun.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("“It’ll be great,” Max said as enthusiastically as he ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("could, considering that he was looking out at waves instead of solid ground. One careless move and the ocean would happily suck both brothers into its dark maw. Max was exhausted from constantly guarding against the danger.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Six weeks on dry land had sounded like pure heaven after three months on the southern Mediterranean searching for treasure. Max had the perfect damn life…and he hated it. Not that he was ungracious enough to let anyone else know that.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced back to Elliott, who was starting to gather up their gear. Elliott was supposed to be learning, and Max knew he should call his brother over and guide him through docking, but he told himself it would be better to wait for nicer weather. Then again, if Elliott rocked the boat into a piling with enough force, the boat would need repairs and they could abandon this so-called vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A wave swelled beneath them, throwing Max into the wheel as if in punishment for his fantasy. “All right,” he muttered into the wind before waving his brother over. “Come on. I’ll guide you through it. You shouldn’t take her out in crud like this, but you never know what’s going to blow in unexpectedly.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("He talked Elliott through the danger of the narrow breakwater and into the marginally calmer waters of the tiny harbor. Five minutes later, his jaw and ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("hands ached from tension, but the boat was safely tied in at one of the slips.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good work,” he said to Elliott, instead of blurting out what he really wanted to say. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Why couldn’t you take up golf like all the other high-level guys at the CDC?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elliott jumped onto the dock and Max handed the bags up to him so they could start the walk to their cabin. “How’d you find this place?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elliott shrugged. “Somebody on one of the boating sites recommended it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Looks nice.” Max jumped up and they walked in silence for a while before he took another look at his brother’s tight shoulders. “Elliott…” he started, wondering if he should mention the ex-wife. What the hell. “You’re not doing all this just because of Rebecca, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Though Max had worried about offending him, Elliott didn’t even look surprised, much less offended. “She was right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Aw, screw her,” Max muttered. “You’re a great guy. You know how many women would kill to marry a guy like you? You’re totally stable. You’re hardworking and honest and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not plugged in, I work too damn much and I’m boring as hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s bullshit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s not bullshit.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max scowled, shifting the duffel bag to his other shoulder. “You love your job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, I love my job, but it can’t be everything. I always worked too much, but after the last flu crisis… I wasn’t even surprised when she left, man. She’d given me enough warning.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Thinking of Rebecca, with her shiny black hair and bright blue eyes, Max shook his head. He’d first met her at his brother’s wedding rehearsal, and his initial impression had been positive. She was lively, a real firecracker, only slightly overwhelmed by the stress of pulling off a perfect wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Six months later, Max had returned from another long stint on the water and found that her liveliness had shifted toward restlessness and impatience with Elliott. Her hostile remarks about Elliott working on weekends had been interspersed with pointed observations about Max’s work. Travel and excitement and weeks in exotic locations. She’d oohed and aahed until Max had been uncomfortable enough to leave early.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("The truth was that life on the sea was utter boredom punctuated by moments of alarm. The tanned skin and windswept hair threw people off. But Rebecca hadn’t been interested in explanations. She’d only been needling her husband. Max hadn’t been surprised by the news that she’d left the day after ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("their first anniversary. Apparently, Elliott hadn’t been, either.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Max cleared his throat. “You’re not trying to get her back, are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elliott surprised him by laughing. “Give me some credit. I know we weren’t right for each other. I just don’t want to make the same mistake again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You dating somebody?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would I be spending a week at the beach with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" if I were?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hell, you’ve already admitted to being bad with women. Wasn’t sure it would occur to you to bring a girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bite me,” Elliott muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Again, better with a girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The punch to his shoulder hurt like a bitch. Despite spending sixty hours a week behind a desk, Elliott wasn’t exactly a weakling, and they’d had plenty of practice whaling on each other as kids. Just as he had when they were young, Max laughed like it hadn’t hurt and pushed his younger brother hard enough to make him stumble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sound and smell of the ocean still pressed in on him, but with his brother’s laughter bouncing off the surrounding boats, Max decided maybe this vacation would be okay after all. But he’d stay on guard against disaster, just as he always did. The ocean had a way of serving up surprises.")])])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page19"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8e6e39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crazyforlove_ch01.vue
// module id = 81
// module chunks = 0